import * as XLSX from 'xlsx';

// Debe coincidir con los encabezados de la plantilla (GET /cotizacion-masiva/plantilla).
export const ENCABEZADOS_BASE = ['Código', 'Moneda', 'UoM'];
const NOMBRE_ARCHIVO = 'cotizacion-masiva-errores.xlsx';

const soloErroneas = (filas) => filas.filter((fila) => fila.estado === 'ERROR');

export function buildErroresAoa(filas) {
  const erroneas = soloErroneas(filas);
  const maxCantidades = Math.max(0, ...erroneas.map((fila) => fila.cantidades?.length ?? 0));
  const encabezado = [
    ...ENCABEZADOS_BASE,
    ...Array.from({ length: maxCantidades }, (_, i) => `Cantidad ${i + 1}`),
    'Estado',
    'Detalle de error',
  ];

  const cuerpo = erroneas.map((fila) => [
    fila.codigoProducto,
    fila.moneda,
    fila.unidadMedida,
    ...Array.from({ length: maxCantidades }, (_, i) => fila.cantidades?.[i] ?? ''),
    fila.estado,
    (fila.errores ?? []).map((error) => error.mensaje).join('; '),
  ]);

  return [encabezado, ...cuerpo];
}

function escribirExcel(aoa, nombreHoja, nombreArchivo) {
  const hoja = XLSX.utils.aoa_to_sheet(aoa);
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, nombreHoja);
  XLSX.writeFile(libro, nombreArchivo);
}

export function exportarErrores(filas) {
  if (!soloErroneas(filas).length) return;
  escribirExcel(buildErroresAoa(filas), 'Errores', NOMBRE_ARCHIVO);
}

const detalleResultado = (fila) =>
  fila.errorProceso || (fila.errores ?? []).map((error) => error.mensaje).join('; ');

export function buildResultadoAoa(filas) {
  const maxCantidades = Math.max(0, ...filas.map((fila) => fila.cantidades?.length ?? 0));
  const encabezado = [
    ...ENCABEZADOS_BASE,
    ...Array.from({ length: maxCantidades }, (_, i) => `Cantidad ${i + 1}`),
    'Número de lote',
    'Número de cotización',
    'Estado final',
    'Detalle',
  ];

  const cuerpo = filas.map((fila) => [
    fila.codigoProducto,
    fila.moneda,
    fila.unidadMedida,
    ...Array.from({ length: maxCantidades }, (_, i) => fila.cantidades?.[i] ?? ''),
    fila.numeroLote ?? '',
    fila.codigoCotizacion ?? '',
    fila.estadoFinal,
    detalleResultado(fila),
  ]);

  return [encabezado, ...cuerpo];
}

export function exportarResultadoCompleto(filas) {
  if (!filas.length) return;
  escribirExcel(buildResultadoAoa(filas), 'Resultado', 'cotizacion-masiva-resultado.xlsx');
}

export function exportarNoProcesados(filas) {
  const noProcesadas = filas.filter((fila) => fila.estadoFinal !== 'COTIZADA');
  if (!noProcesadas.length) return;
  escribirExcel(
    buildResultadoAoa(noProcesadas),
    'No procesados',
    'cotizacion-masiva-no-procesados.xlsx',
  );
}
